import React from "react";

import {
  ChangedList,
  ChannelBlock,
  ChannelName,
  ConfirmField,
  FieldLabel,
} from "../styles";
import { ChannelValue, DefaultSerie, SaleChannel } from "../types";

const show = (value?: number) => (value == null ? "—" : value);

interface ConfirmItem {
  channel: SaleChannel;
  current?: DefaultSerie;
  value?: ChannelValue;
}

const Field: React.FC<{
  label: string;
  previous?: number;
  current?: number;
}> = ({ label, previous, current }) => (
  <ConfirmField>
    <FieldLabel>{label}</FieldLabel>
    <div>Valor anterior: {show(previous)}</div>
    <div>Valor atual: {show(current)}</div>
  </ConfirmField>
);

const ConfirmContent: React.FC<{ items: ConfirmItem[] }> = ({ items }) => (
  <div>
    <p>
      Você está definindo a <strong>série</strong> e o{" "}
      <strong>próximo número inicial</strong> dos canais abaixo. Confirme que o
      próximo número informado corresponde ao número correto da próxima nota da
      série escolhida — caso contrário, pode haver conflito de numeração fiscal
      (notas duplicadas ou com lacunas).
    </p>
    <ChangedList>
      {items.map(({ channel, current, value }) => (
        <ChannelBlock key={channel.id}>
          <ChannelName>{channel.name}</ChannelName>
          <Field
            label="Série"
            previous={current?.serie}
            current={value?.serie}
          />
          <Field
            label="Próximo número"
            previous={current?.invoiceSequence}
            current={value?.invoiceSequence}
          />
        </ChannelBlock>
      ))}
    </ChangedList>
  </div>
);

export default ConfirmContent;
